"use client";

import type { ReactNode } from "react";
import { usePathname } from "next/navigation";
import { isTvKioskPath } from "@/lib/public-routes";

export function HideOnTvKiosk({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  if (isTvKioskPath(pathname)) {
    return null;
  }
  return children;
}
